import auth from "./auth/actions.js";
import mobileConnection from "./mobileConnection/actions.js";

import tokens from "./tokens/actions.js";
import contract from "./contract/actions";

function removeData() {
  return dispatch => {
    dispatch(actions.tokens.changeTokensInfo({}));
    dispatch(actions.auth.changeAuthStatus(false));
    dispatch(actions.contract.changeContractInfo({}));
    dispatch(actions.mobileConnection.changeConnectionData({}));
  };
}

const actions = {
  auth,
  mobileConnection,
  tokens,
  contract,
  removeData,
};

export default actions;
